import {  Routes, Route } from "react-router-dom";
//importing components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

//importing pages------
import Home from "./pages/Home";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Flashcard from "./pages/Flashcard";
import Correction from "./pages/Correction";
import Quiz from "./pages/Quiz";

function App() {
  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/flashcard" element={<Flashcard />} />
        <Route path="/correction" element={<Correction />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        
      </Routes>

      <Footer />
    </>
  );
}

export default App;
